import axios from "axios";

export const state = {
    reportpaymentsbymonths: [],
};

export const getters = {
    reportpaymentsbymonths: state => state.reportpaymentsbymonths,
};

export const mutations = {
    setReportPaymentsbyMonths(reportpaymentsbymonths, newValue) { state.reportpaymentsbymonths = newValue},
};

export const actions = {
    fetchReportPaymentsbyMonths({ commit }) {
        axios.get('/reportpaymentsbymonths').then(res => {
            commit('setReportPaymentsbyMonths', res.data.payments)
        })
    },
    filterReportPaymentsbyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportpaymentsbymonths";
        axios.post(url, formData).then((response) => {
            commit('setReportPaymentsbyMonths', response.data.payments)
        })
    },
};
